import { Component, Input, OnInit } from '@angular/core';

import { Property, PropertySet } from '@mirage-projects/cw-models';

import { PropertyBagService } from '../property-bag.service';

/** This component is responsible to show select property */
@Component({
    selector: 'cw-property-select',
    templateUrl: './property-select.component.html',
    standalone: false,
})
export class PropertySelectComponent implements OnInit {
    /** This object comes from the core and provides methods to obtain and set the value of the properties */
    @Input() propertySet!: PropertySet;

    /** Input field with the required information for this field type */
    @Input() property!: Property;

    options: string[] = [];
    label = '';

    constructor(private propertyBagService: PropertyBagService) {}

    ngOnInit(): void {
        this.label = this.propertyBagService.getCorrectLabel(this.property);
        this.property.value = this.propertyBagService.getValueProperty(this.propertySet, this.property);
        this.options = this.propertyBagService.getValueRange(this.propertySet, this.property);
    }

    onChange(): void {
        this.propertyBagService.setValueProperty(this.propertySet, this.property);
    }
}
